// Chrome-less, read-only board for embedding in third-party pages via an iframe.
// Activated by `?embed=1` on a workflow route; reuses the anonymous/view-only path.
export const EMBED_QUERY_PARAM = 'embed'
export const EMBED_QUERY_VALUE = '1'

// Latched per tab/iframe session, because internal navigations (selecting an event,
// opening a tab) push paths that drop the query param. sessionStorage survives reloads.
const EMBED_STORAGE_KEY = 'qlerify:embed'

const readStickyEmbed = () => {
  try {
    return sessionStorage.getItem(EMBED_STORAGE_KEY) === EMBED_QUERY_VALUE
  } catch (e) {
    return false
  }
}

// Latch embed mode for the session (survives internal navigations that drop the param).
export const latchEmbedMode = () => {
  try {
    sessionStorage.setItem(EMBED_STORAGE_KEY, EMBED_QUERY_VALUE)
  } catch (e) {}
}

// Call once at startup, before the router navigates: the initial URL still carries the
// param on a reload, so latch it for the session (or clear it on a normal load).
export const initEmbedMode = () => {
  try {
    const params = new URLSearchParams(window.location.search)
    if (params.get(EMBED_QUERY_PARAM) === EMBED_QUERY_VALUE) {
      latchEmbedMode()
    } else {
      sessionStorage.removeItem(EMBED_STORAGE_KEY)
    }
  } catch (e) {}
}

// Used by the router to keep `?embed=1` in the URL across internal navigations.
export const isEmbedLatched = () => readStickyEmbed()

// The sticky latch only applies on workflow routes, so embed chrome-hiding can't leak
// onto unrelated pages if an embed session ever navigates away from /workflow/...
export const isEmbedMode = (route) => {
  const hasEmbedQuery = route?.query?.[EMBED_QUERY_PARAM] === EMBED_QUERY_VALUE
  const isWorkflowRoute = !!route?.path?.includes('/workflow/')

  return hasEmbedQuery || (isWorkflowRoute && readStickyEmbed())
}

// `origin` is passed in (not read from window) to keep this testable. The dedicated
// /embed/ path is what CloudFront scopes permissive framing to; the SPA redirects it
// into the workflow route in embed mode.
export const buildEmbedUrl = ({ origin, projectId, workflowId }) =>
  `${origin}/embed/${projectId}/${workflowId}`
